import { TZDate } from '@date-fns/tz';
import { startOfDay, transpose } from 'date-fns';

export const toLocalCalendarDate = (isoDate: string): Date => startOfDay(transpose(new TZDate(isoDate, 'UTC'), Date));
